import React from "react";
import { motion } from "framer-motion";

/**
 * Rotating SVG ring of "circuit nodes" used as hero centerpiece backdrop.
 */
const RotatingRing = () => {
    const nodes = Array.from({ length: 24 });
    return (
        <div className="pointer-events-none absolute inset-0 grid place-items-center">
            <motion.div
                animate={{ rotate: 360 }}
                transition={{ duration: 80, repeat: Infinity, ease: "linear" }}
                className="relative"
                style={{ width: 720, height: 720 }}
            >
                {/* outer ring */}
                <svg viewBox="0 0 720 720" className="absolute inset-0 w-full h-full">
                    <defs>
                        <linearGradient id="ring-grad" x1="0" y1="0" x2="1" y2="1">
                            <stop offset="0%" stopColor="#00E5FF" stopOpacity="0.6" />
                            <stop offset="100%" stopColor="#7C5CFF" stopOpacity="0.2" />
                        </linearGradient>
                    </defs>
                    <circle
                        cx="360"
                        cy="360"
                        r="340"
                        fill="none"
                        stroke="url(#ring-grad)"
                        strokeWidth="1"
                        strokeDasharray="2 6"
                    />
                    <circle
                        cx="360"
                        cy="360"
                        r="270"
                        fill="none"
                        stroke="rgba(255,255,255,0.06)"
                        strokeWidth="1"
                    />
                </svg>
                {nodes.map((_, i) => {
                    const angle = (i / nodes.length) * Math.PI * 2;
                    const r = 340;
                    const x = 360 + r * Math.cos(angle);
                    const y = 360 + r * Math.sin(angle);
                    return (
                        <motion.span
                            key={i}
                            className="absolute h-1.5 w-1.5 rounded-full bg-cyan-300"
                            style={{
                                left: x - 3,
                                top: y - 3,
                                boxShadow: "0 0 12px rgba(0,229,255,0.8)",
                            }}
                            animate={{ opacity: [0.2, 1, 0.2] }}
                            transition={{
                                duration: 2.5,
                                repeat: Infinity,
                                delay: (i / nodes.length) * 2.5,
                            }}
                        />
                    );
                })}
            </motion.div>

            {/* inner reverse ring */}
            <motion.div
                animate={{ rotate: -360 }}
                transition={{ duration: 50, repeat: Infinity, ease: "linear" }}
                className="absolute"
                style={{ width: 460, height: 460 }}
            >
                <svg viewBox="0 0 460 460" className="absolute inset-0 w-full h-full">
                    <circle
                        cx="230"
                        cy="230"
                        r="220"
                        fill="none"
                        stroke="rgba(124,92,255,0.35)"
                        strokeWidth="1"
                        strokeDasharray="1 8"
                    />
                </svg>
            </motion.div>

            {/* center orb */}
            <motion.div
                animate={{ scale: [1, 1.08, 1] }}
                transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
                className="absolute h-40 w-40 rounded-full"
                style={{
                    background:
                        "radial-gradient(circle at 30% 30%, rgba(0,229,255,0.7), rgba(124,92,255,0.45) 50%, transparent 80%)",
                    filter: "blur(20px)",
                }}
            />
        </div>
    );
};

export default RotatingRing;
